// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Atom_Text_Ds = require("../../atom/Atom_Text_Ds.bs.js");
var Particle_Screen_Ds = require("../../particle/Particle_Screen_Ds.bs.js");
var Particle_Background_Ds = require("../../particle/Particle_Background_Ds.bs.js");
var Particle_Screen_Constants = require("../../particle/Particle_Screen_Constants.bs.js");

function make(variant) {
  if (variant === "guidePresse") {
    return {
            autoSize: undefined,
            background: Particle_Background_Ds.background,
            border: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* PresseTextField */23)),
            height: undefined,
            innerSpace: undefined,
            labelStyle: Atom_Text_Ds.Presse.makeDropdown,
            textStyle: Atom_Text_Ds.Presse.makeDropdown,
            itemStyle: Atom_Text_Ds.Dropdown.selectItem
          };
  } else if (variant === "select") {
    return {
            autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
            background: Particle_Background_Ds.background,
            border: undefined,
            height: undefined,
            innerSpace: undefined,
            labelStyle: undefined,
            textStyle: Atom_Text_Ds.Dropdown.current,
            itemStyle: Atom_Text_Ds.Dropdown.selectItem
          };
  } else if (variant === "settings") {
    return {
            autoSize: undefined,
            background: Particle_Background_Ds.background,
            border: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* SettingsDropdown */25)),
            height: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                      NAME: "px",
                      VAL: 60
                    })),
            innerSpace: undefined,
            labelStyle: Atom_Text_Ds.Dropdown.label,
            textStyle: Atom_Text_Ds.Dropdown.current,
            itemStyle: Atom_Text_Ds.Dropdown.selectItem
          };
  } else if (variant === "myProfile") {
    return {
            autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
            background: Particle_Background_Ds.transparent,
            border: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* SettingsDropdown */25)),
            height: undefined,
            innerSpace: undefined,
            labelStyle: undefined,
            textStyle: Atom_Text_Ds.Dropdown.current,
            itemStyle: Atom_Text_Ds.Dropdown.selectItem
          };
  } else if (variant === "presse") {
    return {
            autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
            background: Particle_Background_Ds.background,
            border: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* PresseTextField */23)),
            height: undefined,
            innerSpace: undefined,
            labelStyle: Atom_Text_Ds.Presse.makeDropdown,
            textStyle: Atom_Text_Ds.Presse.makeDropdown,
            itemStyle: Atom_Text_Ds.Dropdown.selectItem
          };
  } else {
    return {
            autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
            background: Particle_Background_Ds.dropdownMenu,
            border: undefined,
            height: undefined,
            innerSpace: undefined,
            labelStyle: undefined,
            textStyle: Atom_Text_Ds.Mona.makeDropdown,
            itemStyle: Atom_Text_Ds.Dropdown.selectItem
          };
  }
}

function makeContainerView(variant) {
  var match = make(variant);
  return {
          autoSize: match.autoSize,
          background: match.background,
          height: match.height,
          innerSpace: match.innerSpace,
          labelStyle: match.labelStyle
        };
}

function makeComponentView(variant) {
  var match = make(variant);
  return {
          border: match.border,
          textStyle: match.textStyle,
          itemStyle: match.itemStyle
        };
}

var Select = {
  makeContainerView: makeContainerView,
  makeComponentView: makeComponentView
};

function make$1(variant) {
  if (variant === "settings") {
    return {
            autoSize: undefined,
            background: Particle_Background_Ds.background,
            border: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* SettingsDropdown */25)),
            height: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                      NAME: "px",
                      VAL: 60
                    })),
            innerSpace: undefined,
            itemCurrentStyle: {
              TAG: /* Setting */17,
              _0: /* Dropdown */2
            },
            itemStyle: /* DropdownItem */10,
            labelStyle: Atom_Text_Ds.Dropdown.label
          };
  } else {
    return {
            autoSize: undefined,
            background: Particle_Background_Ds.background,
            border: undefined,
            height: undefined,
            innerSpace: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")),
            itemCurrentStyle: /* Dropdown */9,
            itemStyle: /* DropdownItem */10,
            labelStyle: Atom_Text_Ds.Dropdown.label
          };
  }
}

function makeContainerView$1(variant) {
  var match = make$1(variant);
  return {
          autoSize: match.autoSize,
          background: match.background,
          height: match.height,
          innerSpace: match.innerSpace,
          labelStyle: match.labelStyle
        };
}

function makeComponentView$1(variant) {
  var match = make$1(variant);
  return {
          border: match.border,
          itemCurrentStyle: match.itemCurrentStyle,
          itemStyle: match.itemStyle
        };
}

var List = {
  makeContainerView: makeContainerView$1,
  makeComponentView: makeComponentView$1
};

exports.Select = Select;
exports.List = List;
/* Atom_Text_Ds Not a pure module */
